import { render, staticRenderFns } from "./OrderCustomerSelect.vue?vue&type=template&id=f7ed677e&"
import script from "./OrderCustomerSelect.vue?vue&type=script&lang=js&"
export * from "./OrderCustomerSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports